<template>
  <div>
    <el-tag
      v-if="rowValue != 0"
      :class="ClassObject"
      style="cursor: pointer"
      @click="onClicked(column, row)"
      plain
    >
      {{ formatterMoney(rowValue) }}
      <!--<span v-if="Months.includes(column.property)"></span>-->
    </el-tag>
  </div>
</template>

<script>
import { formatterMoney } from "@/utils";

export default {
  name: "LinkDialogOpenerForPaymentAndInvoicingReport",
  props: {
    rowValue: {
      type: Number,
      default: 0,
      required: true
    },
    row: {
      type: Object,
      default: () => ({}),
      required: true
    },
    column: {
      type: Object,
      default: () => ({}),
      required: true
    },
    call: {
      type: Function,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      Months: {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12
      }
    };
  },
  computed: {
    ClassObject() {
      const actualMonth = new Date().getMonth();
      const isBlue = false;
      let isRed = false;
      let isGreen = false;
      let isYellow = false;

      switch (this.row.Paid) {
        case true: {
          isGreen = true;
          break;
        }
        case false: {
          isRed = true;
          break;
        }
      }

      if (this.Months[this.column.property] === actualMonth) {
        isYellow = true;
        isRed = false;
        isGreen = false;
      }

      let classObject;
      classObject = {
        Blue: isBlue,
        Red: isRed,
        Green: isGreen,
        Yellow: isYellow,
        Bold: true
      };

      return classObject;
    }
  },
  methods: {
    formatterMoney,
    onClicked(column, row) {
      this.call(column, row);
    }
  }
};
</script>

<style lang="scss" scoped>
.Bold {
  font-weight: bold;
}
.Blue {
  color: blue;
}
.Red {
  color: darkred;
  background-color: lightsalmon;
  border-color: darkred;
}
.Green {
  color: darkgreen;
  background-color: lightgreen;
  border-color: darkgreen;
}
.Yellow {
  color: darkorange;
  background-color: lightgoldenrodyellow;
  border-color: darkorange;
}
</style>
